import axiosInstance from '../AxiosInstance';

export function fetchProfile() {
    return axiosInstance.get('/auth/profile');
}

export function updateProfile(payload) {
    return axiosInstance.put('/auth/profile', payload);
}

export function changePassword(payload) {
    return axiosInstance.put('/auth/password', payload, { skipAuthRedirect: true } as any);
}

export function uploadAvatar(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post('/auth/avatar', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

export function deleteAvatar() {
    return axiosInstance.delete('/auth/avatar');
}

export function uploadCover(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post('/auth/cover', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

export function deleteCover() {
    return axiosInstance.delete('/auth/cover');
}

export function fetchUserSettings() {
    return axiosInstance.get('/user-settings/me');
}

export function updateUserSetting(payload) {
    return axiosInstance.patch('/user-settings/me', payload);
}

export function fetchNotificationPreferences() {
    return axiosInstance.get('/notification-preferences');
}

export function updateNotificationPreference(payload: { notificationType: string; channel: string; enabled: boolean }) {
    return axiosInstance.patch('/notification-preferences', payload);
}
